<template>
    <DashboardContainer>
        <smsHistory/>
    </DashboardContainer>
</template>

<script>
import DashboardContainer from '../containers/DashboardContainer'
import smsHistory from '../components/smsHistory/smsHistory.vue'

export default {
    name: 'attribution',
    beforeCreate: function () {
        var auth = this.$storage.get('auth')
        if (!auth) {
            this.$router.push('/login')
        }else{
            if(!auth.token){
                this.$router.push('/login')
            }
        }
    },
    components: {
        DashboardContainer,
        smsHistory
    }
}
</script>